var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSurveys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M51.583 241.15h-4.344c-.437-1.256-1.58-2.165-2.931-2.165s-2.495.91-2.931 2.166h-4.345c-1.143 0-2.078.975-2.078 2.166v15.163c0 1.191.935 2.166 2.078 2.166h14.55c1.144 0 2.08-.975 2.08-2.166v-15.163c0-1.191-.936-2.166-2.08-2.166zm-7.275 0c.571 0 1.039.488 1.039 1.084 0 .596-.468 1.083-1.04 1.083-.57 0-1.039-.487-1.039-1.083s.468-1.083 1.04-1.083zm0 6.635v-2.031h6.681v2.03h-6.681zm0 8.461v-2.03h6.681v2.03h-6.681zm-6.685-6.43V244.4h5.345v5.415h-5.345zm1.072-4.333v3.25h3.207v-3.25h-3.207zM37.623 257.6v-5.415h5.345v5.415h-5.345zm1.072-4.4v3.25h3.207v-3.25h-3.207z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    transform: "translate(-34 -239)",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSurveys);
export default __webpack_public_path__ + "static/media/ic-surveys.cfde2c5ea668ae8a2df1d43024f0f7aa.svg";
export { ForwardRef as ReactComponent };